import React from 'react'
import { usePathname } from 'next/navigation'
import { Popover } from 'antd'
import { Trans } from '@lingui/react/macro'

import { useSideBarData } from './data'
import IosDownLoadBtn from './_assets/iosDownLoadBtn.svg'

import type { ICommonSideBarProps } from '@/layouts/type'

import Link from '@/components/Link'
import LazyImage from '@/components/LazyImage'


import { useGlobalAudioPlayer } from '@/hooks/audio/store';
import { cls } from 'tagged-classnames-free';
export default function SideBar(props: ICommonSideBarProps) {
  const list = useSideBarData()
  const pathname = usePathname()
  const globalPlayer = useGlobalAudioPlayer()

  const popoverContent = () => {
    return (
      <div className='relative left-[28px] top-8 flex h-[312px] w-[528px] overflow-hidden '>
        <div className='h-[329px] w-[152px] overflow-hidden rounded-lg'>
          <LazyImage
            src='/images/app-download-small.png'
            alt='app-download'
            width={393}
            height={852}
            className='size-full object-contain'
          />
        </div>
        <div className='ml-10 mt-2 w-[277px]'>
          <div>
            <div className='mb-1 flex items-center gap-2'>
              <Trans>Mobile</Trans>
              <IosDownLoadBtn className='max-w-[86px] cursor-pointer hover:scale-110' />
              {/* <AndroidDownLoadBtn className='max-w-[86px] cursor-pointer hover:scale-110' /> */}
            </div>
            <span className='text-f-text-secondary text-sm leading-5'>
              <Trans>
                Create music anytime,
                <br />
                anywhere with the Tad app
              </Trans>
            </span>
          </div>
          <div className='mt-5 flex gap-4'>
            <div className='flex flex-col items-center gap-2'>
              <div className='flex size-[120px] items-center justify-center rounded-lg bg-white'>
                <LazyImage
                  src='/images/ios-download.png'
                  alt='ios-download'
                  width={110}
                  height={110}
                  className='object-contain'
                />
              </div>
              <div className='text-f-text-secondary text-sm leading-5'>iOS</div>
            </div>
            <div className='flex flex-col items-center gap-2'>
              <div className='flex size-[120px] items-center justify-center rounded-lg bg-white'>
                <LazyImage
                  src='/images/android-download.png'
                  alt='android-download'
                  width={110}
                  height={110}
                  className='object-contain'
                />
              </div>
              <div className='text-f-text-secondary text-sm leading-5'>
                Android(APK)
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={cls`bg-f-other-1 sticky left-0 top-0 z-[2] hidden h-screen w-[72px] flex-shrink-0 flex-grow-0 flex-col items-center justify-between self-stretch overflow-visible py-5 sm:flex ${globalPlayer.collapsed ? '' : `pb-[88px]`}`}
    >
      {/* Logo Section */}
      <Link className={cls`flex cursor-pointer flex-col items-center`} href='/'>
        <span
          className={cls`i-cus--tad-logo-ico-04 text-f-text-secondary size-10`}
        ></span>
      </Link>

      {/* Navigation Section */}
      <div className={cls`flex flex-col items-center gap-8`}>
        {list.map((item) => {
          return (
            <Link
              key={item.key}
              href={item.href}
              title={item.title}
              className={cls`${pathname === item.href ? 'text-f-text' : 'text-f-text-quaternary'} hover:text-f-text flex cursor-pointer flex-col items-center gap-1 transition-colors`}
            >
              <div className={cls`relative flex`}>
                <span className={cls`${item.icon} size-6`}></span>
                {item.isNew && (
                  <span
                    className={cls`text-f-text absolute -right-6 -top-1 origin-top-right scale-[.55] rounded rounded-bl-none bg-[linear-gradient(90deg,#FF3466_0%,#FF4BF3_47.92%,#8635FF_100%)] px-1 py-0.5 text-xs font-medium`}
                  >
                    NEW
                  </span>
                )}
              </div>
              <span className={cls`text-xs font-medium`}>{item.label}</span>
            </Link>
          )
        })}
      </div>

      {/* Bottom Actions */}
      <div className={cls`flex flex-col items-center gap-1`}>
        <Popover
          styles={{
            body: {
              backgroundColor: 'var(--f-bg-active)',
              borderRadius: '16px',
              overflow: 'hidden',
            },
          }}
          placement='rightTop'
          trigger='click'
          content={popoverContent}
        >
          <div
            className={cls`text-f-text-quaternary hover:text-f-text-secondary flex size-12 cursor-pointer flex-col items-center justify-center transition-colors`}
          >
            <span className={cls`i-cus--tad-app size-6`}></span>
            <span className={cls`text-xs font-medium`}>
              <Trans>App</Trans>
            </span>
          </div>
        </Popover>
        {/* <div
          className={cls`text-f-text-quaternary hover:text-f-text-secondary flex size-12 cursor-pointer items-center justify-center transition-colors`}
        >
          <span className={cls`i-cus--tad-share-line size-6`}></span>
        </div> */}
      </div>
    </div>
  )
}
